import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getTemplates({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`template/getTemplates/`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createContractPdf({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`template/createContractPdf/`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createByTemplate({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`template/createByTemplate/`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`electronicContract/findAll/`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
